/**
 * The @jsq/observability library is not used in the mobile app because they have a bunch
 * of custom observability tools. This is a small wrapper in case the @jsq/observability
 * library is not actually installed in the consumer.
 */

type ObservabilityLibrary = {
  addError: (message: string, error?: Error) => void;
  addFeatureFlagEvaluation: (flagKey: string, isEnabled: boolean) => void;
};

let observabilityLib: ObservabilityLibrary | null = null;

void (async () => {
  try {
    observabilityLib = await import("@jsq/observability");
  } catch {
    // do nothing, likely mobile environment
  }
})();

export const addError: ObservabilityLibrary["addError"] = (message, error) => {
  observabilityLib?.addError(message, error);
};

export const addFeatureFlagEvaluation: ObservabilityLibrary["addFeatureFlagEvaluation"] = (
  flagKey,
  isEnabled,
) => {
  observabilityLib?.addFeatureFlagEvaluation(flagKey, isEnabled);
};
